import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import { giveawayStore } from '../redux/giveaway.store';
import { giveawayRouter } from './giveaway.router';
const app = /*#__PURE__*/React.createElement(Provider, {
  store: giveawayStore
}, giveawayRouter(giveawayStore, giveawayStore.dispatch));
ReactDom.render(app, document.getElementById('root'));